import appConfig from '@shared/config';

export const PlansServiceMock = adapter =>
  adapter.onGet(`${appConfig.ZION_API}/${appConfig.PLANS_BASE_ENDPOINT}`).reply(200, {
    status: 200,
    data: {
      plans: [
        {
          id: '013351c3-d533-4c7c-b845-4d6f9c539bc6',
          description:
            'Planeje sua adoração diária e adquira bons hábitos rapidamente com versículos bíblicos, devocionais, meditações guiadas e espaço para oração e reflexão.',
          name: 'Devocional diário com Pra. Zoe',
          thumbnail:
            'https://pbs.twimg.com/profile_images/1385931060882587651/hsWDf-Dn_400x400.jpg',
          strategy: 'order',
          slug: 'godsplan',
          subscribed: false,
          planType: 'bible',
        },
        {
          id: 'af14c3b4-be99-48ad-a225-058106631988',
          description:
            'Nós da Família Zion sabemos da importância da Palavra de Deus e em 2023 estamos juntos no propósito de ler a Bíblia durante o ano todo.',
          name: 'Plano de leitura bíblica',
          thumbnail: 'https://media.swncdn.com/cms/CW/faith/60657-bible-teaching-1200.1200w.tn.jpg',
          strategy: 'date',
          slug: 'godsplan2',
          subscribed: true,
          planType: 'bible',
        },
      ],
    },
  });

export const PlanServiceMock = adapter =>
  adapter.onGet(`${appConfig.ZION_API}/${appConfig.PLANS_GOALS_ENDPOINT('godsplan2')}`).reply(200, {
    status: 200,
    data: {
      strategy: 'date',
      goals: [
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fb1b',
          order: 1,
          date: '2022-12-20T00:00:00.000Z',
          completed: true,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: true,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: true,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: true,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fb1e',
          order: 2,
          date: '2022-12-21T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: true,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fb1g',
          order: 3,
          date: '2022-12-22T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fbhh',
          order: 4,
          date: '2022-12-23T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fbhh',
          order: 4,
          date: '2022-12-24T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fbhh',
          order: 4,
          date: '2022-12-25T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
        {
          id: 'd74a05b4-e871-461c-81cf-b5be2802fbhh',
          order: 4,
          date: '2022-12-26T00:00:00.000Z',
          completed: false,
          goalItems: [
            {
              id: 'a1ab2375-cab7-4bb4-a378-3bf9280055ef',
              target: 'gn.1-2',
              isActive: true,
              title: 'Genesis 1-2',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
            {
              id: '34a0b559-9c9a-4c53-9ee8-2f60f9e12257',
              target: 'sl.1',
              isActive: true,
              title: 'Salmos 1',
              completed: false,
            },
          ],
        },
      ],
    },
    response: {
      processStatus: 0,
    },
  });
